mutation CreateAssetsFromOrder(
  $orderReference: String
  $supplier: String
  $purchasedOn: ISO8601Date
  $entity: AssetEntityEnum
  $purchaseCurrency: String
  $purchasedById: ID
  $status: AssetStatusEnum
  $lines: [AssetOrderLineInput!]!
  $assignToEmployeeId: ID
  $assignToLocation: AssetLocationEnum
  $assignedOn: ISO8601Date
  $allowDuplicate: Boolean
) {
  createAssetsFromOrder(
    input: {
      orderReference: $orderReference
      supplier: $supplier
      purchasedOn: $purchasedOn
      entity: $entity
      purchaseCurrency: $purchaseCurrency
      purchasedById: $purchasedById
      status: $status
      lines: $lines
      assignToEmployeeId: $assignToEmployeeId
      assignToLocation: $assignToLocation
      assignedOn: $assignedOn
      allowDuplicate: $allowDuplicate
    }
  ) {
    assets {
      id
      fphNumber
    }
  }
}
